
import Vue, { PropType } from 'vue'
import { DriveDocument } from '@/api/types/drive'
import RCard from '@/components/platform/RCard.vue'
import RButton from '@/components/forms/RButton.vue'
import DriveCardContextMenu from './DriveCardContextMenu.vue'
import { getEtaString } from '@/services/date'
import { driveIsPreparing } from '@/services/selectors'

export default Vue.extend({
  name: 'DriveCard',
  components: {
    RCard,
    RButton,
    DriveCardContextMenu,
  },
  props: {
    drive: {
      type: Object as PropType<DriveDocument>,
      required: true,
    },
    canAssign: {
      type: Boolean,
    },
    files: {
      type: [],
    },
  },
  computed: {
    error(): string {
      return this.drive.display_error
    },
    preparing(): boolean {
      return driveIsPreparing(this.drive)
    },
    eta(): string | null {
      if (this.preparing && this.drive.created) {
        return getEtaString(this.drive.created, 5)
      }
      return null
    },
    browseDisabled(): boolean {
      return this.preparing || !!this.error
    },
  },
})
